/**
 * Mad Hatter Co - Cart Drawer Enhancements
 * ==========================================
 * Handles dynamic updates for the shipping progress bar
 * when cart contents change.
 *
 * Add this file to your Shopify theme's assets/ folder.
 * Include it in layout/theme.liquid before </body>:
 *   <script src="{{ 'mhc-cart-drawer.js' | asset_url }}" defer></script>
 */

(function() {
  'use strict';

  const MHC_SHIPPING_THRESHOLD = 7000; // $70.00 in cents - MUST match your Liquid snippet

  /**
   * Update the shipping bar progress based on current cart total
   */
  function updateShippingBar() {
    const shippingBar = document.querySelector('.mhc-shipping-bar');
    if (!shippingBar) return;

    // Fetch current cart data
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartTotal = cart.total_price; // in cents
        const remaining = MHC_SHIPPING_THRESHOLD - cartTotal;
        const progressPercent = Math.min(100, (cartTotal / MHC_SHIPPING_THRESHOLD) * 100);

        // Update message
        const messageEl = shippingBar.querySelector('.mhc-shipping-bar__message');
        if (messageEl) {
          if (remaining > 0) {
            const remainingFormatted = (remaining / 100).toFixed(2);
            messageEl.innerHTML = `You're <strong>$${remainingFormatted}</strong> away from free shipping`;
            messageEl.classList.remove('mhc-shipping-bar__message--qualified');
          } else {
            messageEl.innerHTML = `You've unlocked <strong>FREE shipping!</strong>`;
            messageEl.classList.add('mhc-shipping-bar__message--qualified');
          }
        }

        // Update progress bar fill
        const fillEl = shippingBar.querySelector('.mhc-shipping-bar__fill');
        if (fillEl) {
          fillEl.style.width = progressPercent + '%';
        }

        // Update truck icon position
        const iconEl = shippingBar.querySelector('.mhc-shipping-bar__icon');
        if (iconEl) {
          iconEl.style.left = progressPercent + '%';
        }
      })
      .catch(err => console.error('MHC: Error fetching cart:', err));
  }

  /**
   * Listen for Horizon theme cart update events
   */
  function initCartListeners() {
    // Horizon uses custom events for cart updates
    // Listen for the section being re-rendered (morphed)
    const observer = new MutationObserver(function(mutations) {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' || mutation.type === 'attributes') {
          const target = mutation.target;
          if (target.closest && (
            target.closest('cart-drawer-component') ||
            target.closest('cart-items-component')
          )) {
            // Debounce the update
            clearTimeout(window._mhcShippingTimeout);
            window._mhcShippingTimeout = setTimeout(updateShippingBar, 300);
          }
        }
      }
    });

    // Observe the cart drawer for changes
    const cartDrawer = document.querySelector('cart-drawer-component');
    if (cartDrawer) {
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true,
        attributes: true,
        attributeFilter: ['class', 'open']
      });
    }

    // Also listen for fetch-based cart updates (backup approach)
    const originalFetch = window.fetch;
    window.fetch = function(...args) {
      return originalFetch.apply(this, args).then(response => {
        const url = args[0];
        if (typeof url === 'string' && (
          url.includes('/cart/change') ||
          url.includes('/cart/add') ||
          url.includes('/cart/update') ||
          url.includes('/cart/clear')
        )) {
          setTimeout(updateShippingBar, 500);
        }
        return response;
      });
    };
  }

  // Initialize when DOM is ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartListeners);
  } else {
    initCartListeners();
  }
})();
